/** Chuẩn hiển thị số dùng xuyên suốt hệ thống: 1.234,56. */
export function normalizeNumber(value: unknown, { allowNegative = false }: { allowNegative?: boolean } = {}): string | null {
  const raw = String(value ?? "").trim().replace(/[\s\u00a0]/g, "");
  if (!raw) return null;
  const sign = raw.startsWith("-") ? "-" : "";
  if ((sign && !allowNegative) || !/^[-]?\d[\d.,]*$/.test(raw)) return null;
  const unsigned = sign ? raw.slice(1) : raw;
  const comma = unsigned.lastIndexOf(",");
  const dot = unsigned.lastIndexOf(".");
  let normalized = unsigned;

  if (comma >= 0 && dot >= 0) {
    normalized = comma > dot
      ? unsigned.replace(/\./g, "").replace(",", ".")
      : unsigned.replace(/,/g, "");
  } else if (comma >= 0 || dot >= 0) {
    const separator = comma >= 0 ? "," : ".";
    const position = comma >= 0 ? comma : dot;
    const count = unsigned.split(separator).length - 1;
    const decimals = unsigned.length - position - 1;
    normalized = count > 1 || decimals === 3
      ? unsigned.replaceAll(separator, "")
      : unsigned.replace(separator, ".");
  }

  if (!/^\d{1,24}(\.\d{1,12})?$/.test(normalized)) return null;
  return `${sign}${normalized}`;
}

/** Định dạng một giá trị số đã có hoặc do API trả về, không làm tròn phần thập phân. */
export function formatNumber(value: unknown, fallback = "—"): string {
  const normalized = normalizeNumber(value, { allowNegative: true });
  if (!normalized) return fallback;
  const sign = normalized.startsWith("-") ? "-" : "";
  const [integer, decimal] = (sign ? normalized.slice(1) : normalized).split(".");
  const grouped = (integer ?? "0").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${sign}${grouped}${decimal === undefined ? "" : `,${decimal}`}`;
}

/** Chuẩn hoá khi người dùng gõ: chỉ nhận ký tự số, tự thêm phân cách nghìn và giữ dấu phẩy thập phân đang gõ. */
export function formatNumberWhileTyping(value: string, { allowNegative = false }: { allowNegative?: boolean } = {}): string {
  const source = value.replace(/[\s\u00a0]/g, "");
  if (!source) return "";
  const cleaned = source.replace(allowNegative ? /[^\d,.-]/g : /[^\d,.]/g, "");
  if (!cleaned || cleaned === "-") return allowNegative && cleaned === "-" ? "-" : "";
  const hasTrailingDecimal = cleaned.endsWith(",");
  const completed = hasTrailingDecimal ? cleaned.slice(0, -1) : cleaned;
  const formatted = formatNumber(completed, "");
  if (!formatted && completed) return "";
  return hasTrailingDecimal ? `${formatted},` : formatted;
}
